import React from 'react'
import {cssVisuallyHidden, Envelope} from '@miro-site/core'
import styled from 'styled-components'
import TopNavigation from './TopNavigation'
import {HeaderAppearance} from '../../types/Header'

const Label = styled.span``

const Icon = styled(Envelope)`
  ${({theme}) =>
    theme.normalizeStyles({
      width: theme.header.topNavigation.contactSales.icon.width,
      height: theme.header.topNavigation.contactSales.icon.height,
      color: 'inherit',
    })}
`

const Link = styled(TopNavigation.Link)`
  ${Label} {
    ${props => props.theme.mq.v2Desktop(cssVisuallyHidden)}
  }

  ${Icon} {
    display: none;

    ${props =>
      props.theme.mq.v2Desktop({
        display: 'block',
      })}
  }
`

const ContactSalesLink = (props: {href: string; label: string; appearance: HeaderAppearance}) => (
  <Link href={props.href} $appearance={props.appearance}>
    <Label>{props.label}</Label>
    <Icon />
  </Link>
)

export default Object.assign(ContactSalesLink, {Label: Label, Icon: Icon})
